
import * as Sentry from '@sentry/react';

export const initSentry = (history?: any) => {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) {
    return;
  }

  const getEnvironment = () => {
    const apiUrl = process.env.REACT_APP_API_BASE_URL || '';
    if (apiUrl.includes('uat')) {
      return 'uat';
    }
    return 'production';
  };

  try {
    Sentry.init({
      dsn,
      environment: getEnvironment(),
      release: 'client-portal@0.1.0',
      sendDefaultPii: true,
      tracePropagationTargets: [
        "https://uat.fulfillmentplusny.com",
        "https://omega.fulfillmentplusny.com",
      ],
      integrations: [
        history
          ? Sentry.reactRouterV5BrowserTracingIntegration({ history })
          : Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
          maskAllInputs: true,
          block: ['.sensitive', '[data-sensitive]'],
          mask: ['[type="password"]', '[data-mask]'],
        }),
      ],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      maxBreadcrumbs: 50,
      maxValueLength: 1000,
      attachStacktrace: true,
      beforeBreadcrumb(breadcrumb: any) {
        if (breadcrumb.category === 'console') {
          return null;
        }
        return breadcrumb;
      },
      beforeSend(event: any) {
        const apiUrl = process.env.REACT_APP_API_BASE_URL || '';
        if (apiUrl.includes('uat')) {
          event.environment = 'uat';
        } else {
          event.environment = 'production';
        }
        if (event.request) {
          if (event.request.headers) {
            delete event.request.headers.moquiSessionToken;
            delete event.request.headers.Authorization;
          }
          if (event.request.data) {
            let data = typeof event.request.data === 'string'
              ? (() => { try { return JSON.parse(event.request.data); } catch { return event.request.data; } })()
              : event.request.data;
            if (data && typeof data === 'object') {
              if ('password' in data) delete (data as any).password;
              if ('moquiSessionToken' in data) delete (data as any).moquiSessionToken;
            }
            event.request.data = typeof event.request.data === 'string'
              ? JSON.stringify(data)
              : data;
          }
        }
        if (event.contexts?.localStorage) {
          delete event.contexts.localStorage.moquiSessionToken;
          delete event.contexts.localStorage.loggedInToken;
        }
        return event;
      },
      ignoreErrors: [
        'top.GLOBALS',
        'originalCreateNotification',
        'canvas.contentDocument',
        'MyApp_RemoveAllHighlights',
        'atomicFindClose',
        'NetworkError',
        'Network request failed',
        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed',
        'Non-Error promise rejection captured',
      ],
    });
  } catch (error) {
  }
};

export const setSentryUser = (user: {
  id?: string;
  email?: string;
  username?: string;
  organizationId?: string;
  facilityId?: string;
}) => {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.username,
  });
  if (user.organizationId) {
    Sentry.setTag('organization', user.organizationId);
  }
  if (user.facilityId) {
    Sentry.setTag('facility', user.facilityId);
  }
};

export const clearSentryUser = () => {
  Sentry.setUser(null);
  Sentry.setTag('organization', null);
  Sentry.setTag('facility', null);
};
